<mat-dialog-content class="mat-typography" style="width: 469px;">
  <div class="section_login">
    <!-- <button style="outline: none;" *ngIf="data.userType.access != 'restric'" class="close-button forgetPass" [mat-dialog-close]="true" id="closeBtn">
      <img src="../../../assets/icons/x-button.svg">
    </button> -->

    <div class="row">
      <div class="col-sm-12">
        <img height="82px" width="82px" [defaultImage]="defaultImage" [lazyLoad]="data.userType.imgPath" style="float: left;">
      </div>
      <div class="col-sm-12 successTitle">
        <h2>{{data.userType.titleOne}}</h2>
        <p>{{data.userType.text}}</p>
      </div>

      <div class="col-md-12">
        <!-- <button  mat-raised-button color="warn" [mat-dialog-close]="true"  (click)="okBtnClick()"  class="">GO Back</button> -->
        <button mat-raised-button style="width: 90%;" color="warn" [mat-dialog-close]="true" (click)="okBtnClick()">Go
          Back</button>
      </div>




    </div>
  </div>
</mat-dialog-content>